import { useTranslation } from 'react-i18next';
import { memo, useState } from 'react';
import { useAtom } from 'jotai';
import { styled } from 'styled-components';
import { showLegendPanelAtom } from '~/components/Map/stores/mapStore';
import { UI_Header, UI_HeaderLeft, UI_HeaderLeft_TabHeader, UI_HeaderRight, UI_HeaderRight_item } from '../PanelStyle';
import { FaXmark } from 'react-icons/fa6';
import { PiBookOpenTextBold, PiListBulletsBold } from 'react-icons/pi';
import ListTab from './ListTab/ListTab';
import LegendTab from './LegendTab/LegendTab';
import { Rnd } from 'react-rnd';

interface LegendPanelProps {
  bgcolor?: string;
}

enum TabEnum {
  LEGEND = 'LEGEND',
  LIST = 'LIST',
}

const LegendPanel = (props: LegendPanelProps) => {
  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState<TabEnum>(TabEnum.LEGEND);
  const [showLegendPanel, setShowLegendPanel] = useAtom<boolean>(showLegendPanelAtom);

  return (
    <Rnd
      default={{
        x: 8,
        y: 32,
        width: 320,
        height: 520,
      }}
      minWidth={280}
      minHeight={250}
      dragHandleClassName="draggable-header"
      cancel=".no-drag, .no-drag *, button, input, textarea, select, a"
      bounds="window"
      enableResizing={{
        bottom: true,
        bottomRight: true,
        right: true,
        top: false,
        topLeft: false,
        topRight: false,
        left: false,
        bottomLeft: false,
      }}
      style={{ zIndex: 900 }}
    >
      <UI_Wrapper>
        <UI_Header className="draggable-header" style={{ cursor: 'move', userSelect: 'none' }}>
          <UI_HeaderLeft className="no-drag" style={{ cursor: 'default' }}>
            <UI_HeaderLeft_TabHeader
              onClick={() => setCurrentTab(TabEnum.LEGEND)}
              className={currentTab === TabEnum.LEGEND ? 'active' : ''}
            >
              <PiBookOpenTextBold style={{ fontSize: '15px' }} />
              <span>Chú giải</span>
            </UI_HeaderLeft_TabHeader>
            <UI_HeaderLeft_TabHeader
              onClick={() => setCurrentTab(TabEnum.LIST)}
              className={currentTab === TabEnum.LIST ? 'active' : ''}
            >
              <PiListBulletsBold style={{ fontSize: '15px' }} />
              <span>Danh sách</span>
            </UI_HeaderLeft_TabHeader>
          </UI_HeaderLeft>
          <UI_HeaderRight className="no-drag" style={{ cursor: 'default' }}>
            <UI_HeaderRight_item
              onClick={() => {
                setShowLegendPanel(false);
              }}
              title="Đóng panel chú giải"
            >
              <FaXmark />
            </UI_HeaderRight_item>
          </UI_HeaderRight>
        </UI_Header>

        <UI_Content>
          {currentTab === TabEnum.LEGEND && <LegendTab />}
          {currentTab === TabEnum.LIST && <ListTab />}
        </UI_Content>
      </UI_Wrapper>
    </Rnd>
  );
};

export default memo(LegendPanel);

const UI_Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: var(--shadows-paneShadow);
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const UI_Content = styled.div`
  padding: 0px 8px;
  flex: 1;
  overflow-y: auto;
`;